import React, { useState } from 'react';
import './RecetarioCarousel.css';

const RecetarioCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const recetas = [
    {
      id: 1,
      titulo: 'Entrecot al Tannat con verduras salteadas',
      descripcion: 'Un entrecot a la plancha o a la parrilla maridado con nuestro Tannat. Las notas especiadas y tánicas del vino realzan la carne y combinan a la perfección con verduras salteadas en manteca y hierbas.',
      vino: 'Tannat Reserva',
      instagramUrl: 'https://www.instagram.com/reel/DMQ45XLxKSx/?igsh=d3hlYWhnaTM1dnh0',
      imagenPreview: require('../assets/entrecot.jpeg'),
      ingredientes: ['Entrecot', 'Verduras de estación', 'Manteca', 'Ajo', 'Cebolla', 'Tannat para reducir'],
      tiempo: '40 minutos'
    },
    {
      id: 2,
      titulo: 'Torta Brownie',
      descripcion: 'Brownie húmedo y con mucho chocolate, ideal para acompañar con un vino dulce o un tinto con notas frutales. El contraste entre lo amargo del cacao y la dulzura del postre crea un maridaje memorable.',
      vino: 'Tannat Reserva / Blend',
      instagramUrl: 'https://www.instagram.com/reel/DLbAG3gx_vk/?igsh=ZzV0MnZlbjduYnY=',
      imagenPreview: require('../assets/brownie.jpeg'),
      ingredientes: ['Chocolate amargo', 'Manteca', 'Huevos', 'Azúcar', 'Harina', 'Vainilla', 'Nueces'],
      tiempo: '1 hora'
    },
    {
      id: 3,
      titulo: 'Ñoquis rellenos',
      descripcion: 'Ñoquis de papa rellenos de queso, con una salsa cremosa o al pesto. Un Chardonnay o un tinto suave acompaña la cremosidad del plato y realza el relleno.',
      vino: 'Chardonnay / Tinto Suave',
      instagramUrl: 'https://www.instagram.com/reel/DN9HBpdjx6Q/?igsh=bWRya296N3VydTV5',
      imagenPreview: require('../assets/noquis.jpeg'),
      ingredientes: ['Papa', 'Harina', 'Muzzarella', 'Huevo', 'Albahaca', 'Salsa elegida'],
      tiempo: '1 hora 30 min'
    }
  ];

  const nextReceta = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % recetas.length);
  };

  const prevReceta = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + recetas.length) % recetas.length);
  };

  return (
    <div className="recetario-section">
      {/* Hero Maridajes */}
      <div className="maridajes-hero">
        <div className="maridajes-hero-overlay"></div>
        <div className="maridajes-hero-content">
          <div className="badge-outline-maridajes">EXPERIENCIAS GASTRONÓMICAS</div>
          <h2 className="maridajes-hero-title">MARIDAJES</h2>
          <p className="maridajes-hero-subtitle">
            Descubrí las combinaciones perfectas entre nuestros vinos y la gastronomía uruguaya
          </p>
        </div>
      </div>

      <div className="recetario-container">

        <div className="carousel-3d-wrapper">
          <button className="carousel-nav-btn prev" onClick={prevReceta}>
            <span>‹</span>
          </button>

          <div className="carousel-3d-container">
            {recetas.map((receta, index) => {
              const offset = index - currentIndex;
              const isActive = index === currentIndex;
              
              return (
                <div
                  key={receta.id}
                  className={`carousel-card ${isActive ? 'active' : ''}`}
                  style={{
                    transform: `
                      translateX(${offset * 100}%) 
                      translateZ(${isActive ? 0 : -200}px) 
                      rotateY(${offset * -15}deg)
                      scale(${isActive ? 1 : 0.8})
                    `,
                    opacity: Math.abs(offset) > 2 ? 0 : isActive ? 1 : 0.5,
                    zIndex: isActive ? 10 : 5 - Math.abs(offset),
                    pointerEvents: isActive ? 'auto' : 'none'
                  }}
                >
                  <div className="card-content">
                    <div className="card-video">
                      <div 
                        className="video-preview" 
                        style={{ backgroundImage: `url(${receta.imagenPreview})` }}
                      />
                    </div>

                    <div className="card-info">
                      <div className="card-info-scroll">
                        <div className="card-badge">{receta.vino}</div>
                        <h3 className="card-titulo">{receta.titulo}</h3>
                        <p className="card-descripcion">{receta.descripcion}</p>

                        <div className="card-detalles">
                          <div className="card-detail">
                            <span className="detail-icon">🕐</span>
                            <span className="detail-text">{receta.tiempo}</span>
                          </div>
                          <div className="card-detail">
                            <span className="detail-icon">👨‍🍳</span>
                            <span className="detail-text">Dificultad: Media</span>
                          </div>
                        </div>

                        <div className="card-ingredientes">
                          <h4>Ingredientes principales:</h4>
                          <ul>
                            {receta.ingredientes.map((ing, i) => (
                              <li key={i}>{ing}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <button className="btn-ver-receta" onClick={() => window.open(receta.instagramUrl, '_blank')}>VER RECETA COMPLETA</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <button className="carousel-nav-btn next" onClick={nextReceta}>
            <span>›</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecetarioCarousel;
